import { render, staticRenderFns } from "./EditCorporativeAccount.vue?vue&type=template&id=137d1250"
import script from "./EditCorporativeAccount.vue?vue&type=script&lang=js"
export * from "./EditCorporativeAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports